module.exports = __webpack_public_path__ + "assets/engagement.c3173a94.svg";